import { ReactNode } from 'react';
// @ts-expect-error react-native-web ships its vendored lists untyped.
import { VirtualizedListContextResetter } from 'react-native-web/dist/vendor/react-native/VirtualizedList/VirtualizedListContext';

/**
 * React context passes through a web `Modal`'s portal, so a list in a
 * sheet opened from a chat row takes itself for one nested in the chat's
 * list: it renders as a plain view that never scrolls, and pages by the
 * chat's scroll. A native `Modal` resets that context; this does the same.
 */
export const ListContextReset = ({ children }: { children: ReactNode }) => (
  <VirtualizedListContextResetter>{children}</VirtualizedListContextResetter>
);
